// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-search__result[data-v-7313e9c2]{overflow:hidden;font-size:16px}.header-search__result__link__avatar[data-v-7313e9c2]{width:40px;height:40px;border-radius:50%;border:solid 1px #e2e2e2}\n", ""]);
// Exports
module.exports = exports;
